import { EventType } from '@app/shared/constants';

// Miroir écran du sceau serveur (server.common.attach-sceau) : sealed, signed_bl, signed_timesheet visé par le responsable.
// sha256 / typ PRINT (PDF de vente d'avant le sceau) : verrou d'écran seul, le serveur ne les scelle pas encore.
export function isSealedAttach(attach: any): boolean {
  const data = attach?.data;
  const flags = data?.['flags'];
  if (Array.isArray(flags)) {
    if (flags.includes('sealed') || flags.includes('signed_bl')) return true;
    if (flags.includes('signed_timesheet') && data?.['hr']?.timesheet_sign?.manager) return true;
  }
  return !!data?.['sha256'] || +(data?.['typ'] ?? 0) === EventType.PRINT;
}
